<div class="flight-summary" *ngIf="bound$ | async as b">
  <h5 class="font-heading-5 bold-type" data-testid="flight-summary-title">
    {{ title }}
  </h5>
  <div class="font-body-1" data-testid="flight-summary-subtitle">
    {{ (bound$ | async).departure.dateTime | finDateFormat: 'FULL' }}
  </div>

  <div class="ms-xsmall-y flex flex-row flex--middle">
    <fin-endpoint-time [endpoint]="b.departure"></fin-endpoint-time>
    <div class="flex--nogrow font-body-1 ps-medium-x">
      <fcom-icon class="icon-medium" [name]="icon$ | async"></fcom-icon>
    </div>
    <fin-endpoint-time [endpoint]="b.arrival" [reverse]="true"></fin-endpoint-time>
  </div>
  <div class="font-body-2 ms-xsmall-b ps-small-r" *ngIf="false">
    <button class="view-detail-button nordic-blue-900-text underline">
      {{ 'ticketSelection.viewTripItineraryDetails' | finLocalization }}
    </button>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1">
    <div class="label nordic-blue-900-text">{{ 'bookingSummary.from.title' | finLocalization }}</div>
    <div class="location medium-type">{{ b.departure['cityName'] }} ({{ b.departure.locationCode }})</div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1">
    <div class="label nordic-blue-900-text">{{ 'bookingSummary.to.title' | finLocalization }}</div>
    <div class="location medium-type">{{ b.arrival['cityName'] }} ({{ b.arrival.locationCode }})</div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1">
    <div class="label nordic-blue-900-text">{{ 'flightDuration' | finLocalization }}</div>
    <div class="duration medium-type">
      {{ 'bookingSearch.duration' | finLocalization: (b?.duration | finTemporaryDurationPipe) }}
    </div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1">
    <div class="label nordic-blue-900-text">{{ 'bookingSummary.numberOfStops' | finLocalization }}</div>
    <div class="stops medium-type" *ngIf="b?.stops !== undefined" [ngSwitch]="b?.stops">
      <ng-container *ngSwitchCase="0">{{ 'bookingSummary.directFlight' | finLocalization }}</ng-container>
      <ng-container *ngSwitchCase="1">{{ 'stopOver' | finLocalization: [b?.stops] }}</ng-container>
      <ng-container *ngSwitchDefault>{{ 'stopOvers' | finLocalization: [b?.stops] }}</ng-container>
    </div>
  </div>
  <div class="summary-info ms-xsmall-b font-body-1" *ngIf="b?.fareFamily?.name">
    <div class="label nordic-blue-900-text">{{ 'bookingSummary.ticketType' | finLocalization }}</div>
    <div class="ticket-type medium-type">{{ b?.fareFamily?.name }}</div>
  </div>
  <div class="summary-info font-body-1" *ngIf="flights$ | async as flights">
    <ng-container *ngIf="flights[0].bookingClass">
      <div class="ms-xsmall-b">
        <div class="label nordic-blue-900-text">{{ 'travelClasses' | finLocalization }}</div>
        <div *ngFor="let flight of flights" class="medium-type" data-testid="booking-summary-flights">
          {{ flight.departure.locationCode }}—{{ flight.arrival.locationCode }}
          <ng-container *ngIf="flight.cabinClass">
            {{ 'travelClass.' + flight.cabinClass?.toLowerCase() | finLocalization }} {{ flight.bookingClass }}
          </ng-container>
          <ng-container *ngIf="!flight.cabinClass">
            {{ 'bookingSummary.noTravelClass' | finLocalization }}
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="label nordic-blue-900-text">{{ 'bookingSummary.operatedBy' | finLocalization }}</div>
    <div *ngFor="let flight of flights" class="medium-type">
      {{ flight.departure.locationCode }}—{{ flight.arrival.locationCode }} {{ flight.operatingAirline?.name }}
    </div>
  </div>
</div>
